import get from '@/api/base/with-authorization/get';
/**
 * Fetch a list of venues.
 *
 * @returns {Promise}
 */
export default function () {
    return get('venue/');
}
